// apps/web/src/pages/admin/manual-create/manual-create-operations.ts — Phase 5 plan 05-04.

import { gql } from "graphql-request";

export const CREATE_MANUAL_RESERVATION_MUTATION = gql`
  mutation CreateManualReservationAdmin($input: CreateManualReservationInput!) {
    createManualReservation(input: $input) {
      reservationNumber
      selfServiceToken
      selfServiceUrl
      expiresAt
    }
  }
`;

export const SLOT_DEFINITIONS_QUERY = gql`
  query SlotDefinitionsManual {
    slotDefinitions {
      id
      startTime
      durationMinutes
    }
  }
`;

export const RESTAURANT_MANUAL_QUERY = gql`
  query RestaurantManual {
    restaurant {
      id
      minPartySize
      maxPartySize
      timezone
    }
  }
`;
